import graphql from "babel-plugin-relay/macro";

export const patronImageKitAuthMutation = graphql`
  mutation usePatronImageKitAuthMutation($clubId: ID!, $format: String!) {
    imagekitUploadAuth(clubId: $clubId, format: $format) {
      token
      fileName
      folder
      checks
      useUniqueFileName
      overwriteFile
      renderingBaseUrl
    }
  }
`;
